<template>
  <v-card
    class="mx-auto"
    color="grey lighten-4"
    min-width="450"
  >
    <v-img height="130" v-if="item.imagens.length > 0" :src="item.imagens[0]"/>
    <v-card
      v-else
      color="#EBEBEB"
      height="130"
      style="border-radius: 1em 1em 0em 0em;"
      elevation="0"
    >
      <v-layout justify-center align-center fill-height column>
          <v-icon
            v-if="!item.combustivel"
            size="6em"
            :color="item.combustivel ? item.combustivel.color : item.categoria.cor"
          >
          {{ item.categoria.icone }}
        </v-icon>
        <svg-filler
          v-else
          :path="require(`@/assets/combs/${item.combustivel.icone}.svg`)"
          width="6em"
          height="6em"
          :fill="item.combustivel.color"
          class="mr-2"
        />
      </v-layout>
    </v-card>
    <v-card-title
      class="mt-0 pt-0"
      :style="{'color': item.combustivel ? item.combustivel.color : item.categoria.cor}"
    >
    </v-card-title>
    <v-card-text
      class="pb-0 pt-0 mb-4"
      v-if="smartLock"
    >
      <v-list v-if="item.ofertas && item.ofertas.length" class="transparent" subheader>
        <template>
          <template v-for="(oferta, index) in item.ofertas">
            <v-list-tile
              v-if="!oferta.promocao"
              :key="index"
              ripple
              @click="() => { ofertaSelected = oferta; cancelarOfertaDialog = true }"
            >
              <v-list-tile-avatar>
                <v-tooltip bottom>
                  <v-icon slot="activator" :color="`${oferta && oferta.para_assinantes ? 'secondary' : ''}`">
                    {{ iconeDestinoOferta(oferta) }}
                  </v-icon>
                  <span>
                    {{
                      oferta.rede ? oferta.rede.tipo_rede === 0 ? 'Válida para App do posto' : 'Válida para app do sindicato' : 'Válida para app Apetrus'
                    }}
                  </span>
                </v-tooltip>
              </v-list-tile-avatar>
              <v-list-tile-action
                :class="`${oferta && oferta.para_assinantes ? 'secondary' : ''}--text`"
                style="font-size: 1.1em; font-weight: normal;"
              >
                <h5 v-if="oferta.percentual_desconto !== null">
                  {{oferta.percentual_desconto}}%
                </h5>
                <h5
                  v-else-if="oferta.desconto_em_reais !== null"
                >
                  {{oferta.desconto_em_reais | currency({ frameElement: 2 })}}
                </h5>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title
                  :class="`${oferta.para_assinantes ? 'secondary' : ''}--text pt-1`"
                >
                  Oferta: {{ calcularDesconto(item.preco, oferta.percentual_desconto, oferta.desconto_em_reais) }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-avatar v-if="oferta.para_assinantes">
                <v-tooltip bottom>
                  <v-icon
                    class="ml-3"
                    slot="activator"
                    color="secondary"
                  >
                    star
                  </v-icon>
                  Apenas Para Assinantes
                </v-tooltip>
              </v-list-tile-avatar>
              <v-list-tile-action>
                <v-icon
                  small
                  :color="`${oferta && oferta.para_assinantes ? 'secondary' : 'grey'} lighten-1`"
                >
                  pan_tool
                </v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile v-else-if="oferta.promocao"
              :key="index"
            >
              <v-list-tile-avatar>
                <v-tooltip bottom>
                  <v-icon slot="activator" :color="`${oferta.para_assinantes ? 'secondary' : ''}`">
                    {{ iconeDestinoOferta(oferta) }}
                  </v-icon>
                  <span>
                    {{
                      oferta.rede ? oferta.rede.tipo_rede === 0 ? 'Válida para App do posto' : 'Válida para app do sindicato' : 'Válida para app Apetrus'
                    }}
                  </span>
                </v-tooltip>
              </v-list-tile-avatar>
              <v-list-tile-action
                :class="`${oferta && oferta.para_assinantes ? 'secondary' : ''}--text`"
                style="font-size: 1.1em; font-weight: normal;"
              >
                <h5 v-if="oferta.percentual_desconto !== null">
                  {{oferta.percentual_desconto}}%
                </h5>
                <h5
                  v-else-if="oferta.desconto_em_reais !== null"
                >
                  {{oferta.desconto_em_reais | currency({ frameElement: 2 })}}
                </h5>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title
                  :class="`${oferta.para_assinantes ? 'secondary' : ''}--text pt-1`"
                >
                  Promoção: {{ calcularDesconto(item.preco, oferta.percentual_desconto, oferta.desconto_em_reais) }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action
                v-if="new Date(`${oferta.data_fim}T23:59:59`) >= new Date()"
                :class="`${oferta && oferta.para_assinantes ? 'secondary' : ''}--text`"
              >
                <v-list-tile-action-text
                  :class="`${oferta && oferta.para_assinantes ? 'secondary' : ''}--text`"
                >
                  Início: {{ oferta.data_inicio | formatDate('DD/MM') }}
                </v-list-tile-action-text>
                <v-list-tile-action-text
                  :class="`${oferta && oferta.para_assinantes ? 'secondary' : ''}--text`"
                >
                  Fim: {{ oferta.data_fim | formatDate('DD/MM') }}
                </v-list-tile-action-text>
              </v-list-tile-action>
               <v-list-tile-action v-else>
                 <v-list-tile-action-text
                    style="color: #8B0000;"
                    class="ml-3"
                  >
                    Data expirou
                  </v-list-tile-action-text>
              </v-list-tile-action>
              <v-list-tite-avatar
                class="ml-2"
                v-if="oferta.para_assinantes"
              >
                <v-tooltip bottom>
                  <v-icon
                    slot="activator"
                    color="secondary"
                  >
                    star
                  </v-icon>
                  <span>
                    Apenas Para Assinantes
                  </span>
                </v-tooltip>
              </v-list-tite-avatar>
              <v-list-tile-action>
                <v-menu offset-x max-width="250" right>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon :color="`${oferta && oferta.para_assinantes ? 'secondary' : 'grey'} darken-2`">more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="pa-0">
                    <v-list-tile ripple @click="carregarBanner(oferta)">
                      <v-list-tile-content>
                        <v-list-tile-title
                          class="font-weight-light body-1 success--text text-xs-center"
                        >CARREGAR BANNER</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon color="success">image</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile
                      ripple
                      @click="() => { ofertaSelected = oferta; cancelarOfertaDialog = true }"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title
                          class="font-weight-light body-1 error--text text-xs-center"
                        >CANCELAR PROMOÇÃO</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon color="error">close</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </template>
      </v-list>
      <template v-if="notificacoes && notificacoes.length">
        <template v-for="(notificacao, index) in notificacoes">
          <div :key="index" class="notificacao">
            <span>*{{notificacao}}</span>
          </div>
        </template>
      </template>
      <v-dialog lazy v-model="cancelarOfertaDialog" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Interromper esta oferta?</v-card-title>
          <v-card-text>Depois de confirmar, seus clientes não poderão mais comprar com este desconto!</v-card-text>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    v-model="opcao_exclusao"
                    outline
                    :items="[
                      { text: 'Cancelar para esse combustível', value: 1 },
                      { text: 'Cancelar essa oferta para todos combustíveis', value: 2 },
                      { text: 'Cancelar todas as ofertas do posto', value: 3 },
                    ]"
                    label="Selecione uma opção de cancelamento"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    outline
                    v-model="motivoCancelamento"
                    name="input-7-4"
                    label="Motivo do cancelamento"
                    value
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-space-between">
            <v-btn color="grey" flat @click="cancelarOfertaDialog = false">Não!</v-btn>
            <v-btn
              color="green darken-1"
              flat
              @click="cancelarOferta(ofertaSelected, motivoCancelamento)"
            >Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
    <v-toolbar
      :color="item.combustivel ? item.combustivel.color : item.categoria.cor"
      style="color: white;"
    >
      <h3 class="font-weight-bold">{{item.nome.toUpperCase()}}</h3>
      <v-spacer></v-spacer>
      <span class="subheading font-weight-bold">{{ item.preco | currency({fractionCount: 2}) }}</span>
    </v-toolbar>
    <v-card-actions class="justify-space-around">
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="$emit('visualizarItem', item)">
          <v-icon>visibility</v-icon>
        </v-btn>
        <h4>Visualizar Item</h4>
      </v-tooltip>
      <v-divider vertical></v-divider>
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="$emit('editarItem', item)">
          <v-icon>edit</v-icon>
        </v-btn>
        <h4>Editar Item</h4>
      </v-tooltip>
      <v-divider vertical></v-divider>
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="$emit('editarDisponibilidade', item)">
          <v-icon>{{ item.disponivel ? 'check_circle' : 'cancel' }}</v-icon>
        </v-btn>
        <h4>Editar Disponibilidade</h4>
      </v-tooltip>
      <v-divider vertical></v-divider>
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="$emit('deletarItem', item)">
          <v-icon>close</v-icon>
        </v-btn>
        <h4>Deletar Item</h4>
      </v-tooltip>
    </v-card-actions>
    <v-dialog
      width="500"
      lazy
      persistent
      v-model="dialogBannerPromocional"
    >
      <carregar-banner v-if="promocaoBanner" @close="(url_imagem_promocao) => closeBannerDialog(promocaoBanner, url_imagem_promocao)" :promocao="promocaoBanner"></carregar-banner>
    </v-dialog>
  </v-card>
</template>

<script>
import CarregarBanner from '@/components/CarregarBannerPromocional'
export default {
  components: { CarregarBanner },
  props: ['item'],
  data () {
    return {
      promocaoBanner: null,
      cancelarOfertaDialog: false,
      dialogBannerPromocional: false,
      motivoCancelamento: '',
      ofertaSelected: null,
      dialogCodigoPromocional: false,
      dialogCadastrarOferta: false,
      dialogCadastrarPromocao: false,
      dialogAlterarPrecoBomba: false,
      dialogListOfertas: false,
      notificacoes: [],
      opcao_exclusao: 1
    }
  },
  computed: {
    combustiveisSilenciados () {
      return this.$store.getters.combustiveisSilenciados
    },
    smartLock () {
      const pessoa = this.$store.getters.pessoa
      if (pessoa) {
        return this.$store.getters.smartLock || !pessoa.smartlock_posto
      } else {
        return this.$store.getters.smartLock
      }
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    iconeDestinoOferta (oferta) {
      if (oferta && oferta.rede) {
        if (oferta.rede.tipo_rede === 0) return 'phone_iphone'
        else return 'handshake'
      }
      return 'local_gas_station'
    },
    closeBannerDialog (oferta, bannerUrl) {
      if (bannerUrl) oferta.url_imagem_promocao = bannerUrl
      this.promocaoBanner = null
      this.dialogBannerPromocional = false
    },
    carregarBanner (oferta) {
      this.promocaoBanner = oferta
      this.dialogBannerPromocional = true
    },
    novaOferta () {
      this.$emit('novaOferta')
      this.dialogCadastrarOferta = !!this.item.preco
      if (!this.dialogCadastrarOferta) {
        this.castError(
          'Você precisa ter um preço de bomba ativo para inserir a oferta'
        )
      }
    },
    calcularDesconto (preco, percentual, descontoEmReais) {
      if (percentual) {
        const valorComDesconto = (preco - preco * (percentual / 100)).toFixed(8) // Faz calculo é obriga a função a trabalhar com 4 digitos
        if (this.posto.truncamento_combustivel) { // Se é truncamento
          return 'R$ ' + valorComDesconto.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] // Remove casas decimais adicionais e conserva o número
        } else { // Se trucamento não está ativo
          const casasDecimais = valorComDesconto.toString().split('.')[1]
          const algarismoConservado = Math.floor(valorComDesconto * 100) % 10
          const algarismoSeguinteAoConservado = Math.floor(valorComDesconto * 1000) % 10
          const algarismoSeguinteSeguidoDeZeros = casasDecimais.substring(3).split('').some(numeroDecial => numeroDecial !== '0')
          if (algarismoSeguinteAoConservado < 5) {
            return 'R$ ' + valorComDesconto.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
          } else if (algarismoSeguinteSeguidoDeZeros) {
            return 'R$ ' + (parseFloat(valorComDesconto) + 0.001).toFixed(2)
          } else if (algarismoSeguinteAoConservado === 5 && !algarismoSeguinteSeguidoDeZeros) {
            if (algarismoConservado % 2 === 0) {
              return 'R$ ' + valorComDesconto.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
            } else {
              return 'R$ ' + (parseFloat(valorComDesconto) + 0.001).toFixed(2)
            }
          }
          return 'R$ ' + (parseFloat(valorComDesconto) + 0.001).toFixed(2)
        }
      } else if (descontoEmReais) {
        return 'R$ ' + (preco - descontoEmReais).toFixed(2)
      }
      return 'R$ ' + preco
    },
    cancelarOferta (oferta, motivoCancelamento) {
      this.$store
        .dispatch('ofertas', {
          id: oferta.id,
          method: 'DELETE',
          body: {
            motivo_cancelamento: motivoCancelamento,
            item: this.item.id,
            posto: this.posto.cnpj,
            opcao_exclusao: this.opcao_exclusao
          }
        })
        .then(() => {
          this.$emit('carregar')
          motivoCancelamento = ''
          oferta = null
          this.cancelarOfertaDialog = false
        })
      // cancelarOfertaDialog = false
    },
    castError (error) {
      this.$emit('error', error)
    },
    verificarValor () {
      if (this.item.preco && this.item.preco.toString().includes('.')) {
        return this.item.preco.toString().split('.')[1].length > 2
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.notificacao {
  color: #8B0000 !important;
  font-size: 9pt;
}
</style>
